import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
const titleCase = (value) =>
  value
    .split("-")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");

const buildFinalPath = (itemName, sub) => {
  const subPath = typeof sub === "string" ? sub : sub.path;
  if (subPath.includes("/")) return `/${subPath}`;
  const flatSections = ["about us", "policy library", "media"];
  if (flatSections.includes(itemName.toLowerCase())) return `/${subPath}`;
  return `/${itemName.toLowerCase()}/${subPath}`;
};

const MobileHeader = ({
  menuItems,
  districts,
  districtsLoading,
  industries,
  industriesLoading,
  isAdmin,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [openTop, setOpenTop] = useState(null);
  const [openNested, setOpenNested] = useState(null);

  useEffect(() => {
    document.body.style.overflow = isOpen ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [isOpen]);

  const closeAll = () => {
    setIsOpen(false);
    setOpenTop(null);
    setOpenNested(null);
  };

  const toggleTop = (name) => {
    setOpenTop((prev) => (prev === name ? null : name));
    setOpenNested(null);
  };

  const toggleNested = (key) => {
    setOpenNested((prev) => (prev === key ? null : key));
  };

  return (
    <div className="mh-root">
      <style>{`
        .mh-root { display: none; }

        @media (max-width: 991px) {
          .mh-root { display: block; }

          .mh-topbar {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 10px 16px;
            background: #fff;
          }
          .mh-logo img { height: 60px; width: auto; }
          .mh-tagline {
            flex: 1;
            min-width: 0;
            padding: 0 12px;
            font-size: 13px;
            font-weight: 600;
            color: #470172;
            text-align: center;
            line-height: 1.3;
          }
          .mh-toggler {
            border: none;
            background: #470172;
            border-radius: 6px;
            padding: 8px;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            color: #fff;
          }

          .mh-overlay {
            position: fixed;
            inset: 0;
            background: #fff;
            z-index: 10000;
            display: flex;
            flex-direction: column;
            transform: translateX(100%);
            transition: transform 0.28s ease-in-out;
            overflow-y: auto;
          }
          .mh-overlay.mh-open {
            transform: translateX(0);
          }

          .mh-panel-header {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 14px 16px;
            border-bottom: 1px solid #eee;
            position: sticky;
            top: 0;
            background: #fff;
            z-index: 1;
          }
          .mh-panel-header img { height: 44px; width: auto; }
          .mh-panel-tagline {
            flex: 1;
            min-width: 0;
            padding: 0 12px;
            font-size: 13px;
            font-weight: 600;
            color: #470172;
            text-align: left;
            line-height: 1.3;
          }
          .mh-close {
            border: none;
            background: transparent;
            font-size: 28px;
            line-height: 1;
            color: #470172;
            cursor: pointer;
            padding: 4px 8px;
          }

          .mh-list {
            list-style: none;
            margin: 0;
            padding: 8px 0 24px;
          }
          .mh-list a, .mh-row-toggle {
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 100%;
            padding: 14px 20px;
            font-size: 16px;
            color: #262626;
            text-decoration: none;
            background: transparent;
            border: none;
            text-align: left;
            font-family: inherit;
            cursor: pointer;
          }
          .mh-list a.mh-active-link { color: #470172; font-weight: 600; }
          .mh-chevron {
            transition: transform 0.2s ease;
            flex-shrink: 0;
            margin-left: 8px;
          }
          .mh-chevron.mh-rotated { transform: rotate(180deg); }

          .mh-sublist {
            list-style: none;
            margin: 0;
            padding: 0;
            background: #faf9fc;
          }
          .mh-sublist a, .mh-sublist .mh-row-toggle {
            padding: 12px 20px 12px 36px;
            font-size: 15px;
            color: #444;
          }
          .mh-nested-list a {
            padding: 10px 20px 10px 52px;
            font-size: 14px;
            color: #555;
          }

          .mh-loading, .mh-empty {
            padding: 12px 36px;
            font-size: 14px;
            color: #888;
          }

          .mh-admin-link {
            color: #b8860b !important;
            font-weight: 600 !important;
          }
        }
      `}</style>

      <div className="mh-topbar">
        <Link to="/" className="mh-logo" onClick={closeAll}>
          <img src="/img/aid.svg" alt="AID" />
        </Link>
        <span className="mh-tagline">Association for Industrial Development</span>
        <button
          type="button"
          className="mh-toggler"
          aria-label="Open menu"
          aria-expanded={isOpen}
          onClick={() => setIsOpen(true)}
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="3" y1="12" x2="21" y2="12"></line>
            <line x1="3" y1="6" x2="21" y2="6"></line>
            <line x1="3" y1="18" x2="21" y2="18"></line>
          </svg>
        </button>
      </div>

      <div className={`mh-overlay ${isOpen ? "mh-open" : ""}`}>
        <div className="mh-panel-header">
          <Link to="/" onClick={closeAll}>
            <img src="/img/aid.svg" alt="AID" />
          </Link>
          <span className="mh-panel-tagline">Association for Industrial Development</span>
          <button
            type="button"
            className="mh-close"
            aria-label="Close menu"
            onClick={closeAll}
          >
            &times;
          </button>
        </div>

        <ul className="mh-list">
          <li>
            <Link to="/" onClick={closeAll}>Home</Link>
          </li>
          <li>
            <Link to="/vidarbha" onClick={closeAll}>Vidarbha Corridor</Link>
          </li>

          {/* Districts */}
          <li>
            <button
              type="button"
              className="mh-row-toggle"
              onClick={() => toggleTop("district")}
            >
              Districts
              <svg
                className={`mh-chevron ${openTop === "district" ? "mh-rotated" : ""}`}
                width="16" height="16" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
              >
                <polyline points="6 9 12 15 18 9"></polyline>
              </svg>
            </button>
            {openTop === "district" && (
              <ul className="mh-sublist">
                {districtsLoading ? (
                  <li className="mh-loading">Loading districts...</li>
                ) : districts && districts.length > 0 ? (
                  districts.map((district) => (
                    <li key={district._id}>
                      <Link to={`/district/${district._id}`} onClick={closeAll}>
                        {district.districtName}
                      </Link>
                    </li>
                  ))
                ) : (
                  <li className="mh-empty">No districts available</li>
                )}
              </ul>
            )}
          </li>

          {/* Industry */}
          <li>
            <button
              type="button"
              className="mh-row-toggle"
              onClick={() => toggleTop("industry")}
            >
              Industry
              <svg
                className={`mh-chevron ${openTop === "industry" ? "mh-rotated" : ""}`}
                width="16" height="16" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
              >
                <polyline points="6 9 12 15 18 9"></polyline>
              </svg>
            </button>
            {openTop === "industry" && (
              <ul className="mh-sublist">
                {industriesLoading ? (
                  <li className="mh-loading">Loading industries...</li>
                ) : industries && industries.length > 0 ? (
                  industries.map((industry) => (
                    <li key={industry._id}>
                      <Link to={`/industrypage/${industry._id}`} onClick={closeAll}>
                        {industry.sectorName || industry.name || "Unnamed Industry"}
                      </Link>
                    </li>
                  ))
                ) : (
                  <li className="mh-empty">No industries available</li>
                )}
              </ul>
            )}
          </li>

          {/* Remaining top-level menu items, driven by the same data desktop uses */}
          {menuItems.map((item) => {
            if (item.submenu) {
              // Mobile-only: "Blog" already lives under Media's submenu for
              // desktop's dropdown — on mobile it instead gets its own
              // top-level item right after Media, so filter it out here to
              // avoid showing it twice in the mobile menu.
              const mobileSubmenu = item.name === "Media"
                ? item.submenu.filter((sub) => sub !== "blog")
                : item.submenu;

              return (
                <React.Fragment key={item.name}>
                <li>
                  <button
                    type="button"
                    className="mh-row-toggle"
                    onClick={() => toggleTop(item.name)}
                  >
                    {item.name}
                    <svg
                      className={`mh-chevron ${openTop === item.name ? "mh-rotated" : ""}`}
                      width="16" height="16" viewBox="0 0 24 24" fill="none"
                      stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
                    >
                      <polyline points="6 9 12 15 18 9"></polyline>
                    </svg>
                  </button>
                  {openTop === item.name && (
                    <ul className="mh-sublist">
                      {mobileSubmenu.map((sub) => {
                        if (sub.submenu) {
                          const nestedKey = `${item.name}-${sub.label}`;
                          return (
                            <li key={nestedKey}>
                              <button
                                type="button"
                                className="mh-row-toggle"
                                onClick={() => toggleNested(nestedKey)}
                              >
                                {sub.label}
                                <svg
                                  className={`mh-chevron ${openNested === nestedKey ? "mh-rotated" : ""}`}
                                  width="14" height="14" viewBox="0 0 24 24" fill="none"
                                  stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
                                >
                                  <polyline points="6 9 12 15 18 9"></polyline>
                                </svg>
                              </button>
                              {openNested === nestedKey && (
                                <ul className="mh-nested-list">
                                  {sub.submenu.map((nestedSub) => (
                                    <li key={nestedSub.path}>
                                      <Link to={`/${nestedSub.path}`} onClick={closeAll}>
                                        {nestedSub.label}
                                      </Link>
                                    </li>
                                  ))}
                                </ul>
                              )}
                            </li>
                          );
                        }

                        const subPath = typeof sub === "string" ? sub : sub.path;
                        const subLabel =
                          typeof sub === "string" ? titleCase(sub) : sub.label;
                        const finalPath = buildFinalPath(item.name, sub);

                        return (
                          <li key={subPath}>
                            <Link to={finalPath} onClick={closeAll}>
                              {subLabel}
                            </Link>
                          </li>
                        );
                      })}
                    </ul>
                  )}
                </li>
                {item.name === "Media" && (
                  <li>
                    <Link to="/blog" onClick={closeAll}>Blogs</Link>
                  </li>
                )}
                </React.Fragment>
              );
            }

            if (item.externalLink) {
              return (
                <li key={item.name}>
                  <a
                    href={item.externalLink}
                    target={item.openInNewTab ? "_blank" : "_self"}
                    rel={item.openInNewTab ? "noopener noreferrer" : undefined}
                    onClick={closeAll}
                  >
                    {item.name}
                  </a>
                </li>
              );
            }

            return (
              <li key={item.name}>
                <Link
                  to={item.to}
                  onClick={closeAll}
                  className={item.name === "Join Us" ? "mh-active-link" : ""}
                >
                  {item.name}
                </Link>
              </li>
            );
          })}

          {isAdmin && (
            <li>
              <Link to="/admin" onClick={closeAll} className="mh-admin-link">
                Admin Panel
              </Link>
            </li>
          )}
        </ul>
      </div>
    </div>
  );
};

export default MobileHeader;
